<template>
  <div class="header">
    <AGBreadcrumb :items="itemsBreadCrumb" />
    <div class="d-flex align-end justify-space-between flex-wrap my-8">
      <v-row>
        <v-col class="py-0" cols="12">
          <slot v-if="!loading" name="prepend" />
          <v-progress-linear v-if="loading" color="#ECE7F5" height="48px" class="mb-2 rounded" indeterminate />
          <h2 v-else class="mb-2 header__title">{{ title }}</h2>
          <p v-if="subtitle" class="header__subtitle">{{ subtitle }}</p>
        </v-col>
      </v-row>
      <div>
        <div class="d-flex flex-row-reverse" style="gap: 16px">
          <AGButton
            v-if="hasAddButton"
            left-icon="mdi-plus"
            type="primary"
            :disabled="disableAddButton"
            @click="clickAdd"
          >
            {{ addButtonText }}
          </AGButton>
          <AGButton v-if="hasConfigButton" left-icon="mdi-cog-outline" type="secondary" @click="clickConfig">
            {{ configButtonText }}
          </AGButton>
          <slot />
        </div>
        <UpdateInfo v-if="hasUpdateInfo" class="mt-2" :last-process-data="lastProcessData" @click="clickUpdateInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import AGBreadcrumb from '@/components/common/AGBreadcrumb.vue';
import AGButton from '@/components/common/AGButton.vue';
import UpdateInfo from '@/components/common/UpdateInfo.vue';

export default {
  components: {
    UpdateInfo,
    AGButton,
    AGBreadcrumb,
  },

  emits: ['click:add', 'click:config', 'click:update-info'],

  props: {
    title: {
      type: String,
      default: '',
    },

    subtitle: {
      type: String,
      default: '',
    },

    itemsBreadCrumb: {
      required: true,
      type: Array,
      default: () => [],
    },

    hasAddButton: {
      type: Boolean,
      default: false,
    },

    addButtonText: {
      type: String,
      default: 'Adicionar',
    },

    hasConfigButton: {
      type: Boolean,
      default: false,
    },

    configButtonText: {
      type: String,
      default: 'Configurações',
    },

    hasUpdateInfo: {
      type: Boolean,
      default: false,
    },

    lastProcessData: {
      type: String,
      default: undefined,
    },

    disableAddButton: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    clickAdd(e) {
      this.$emit('click:add', e);
    },

    clickConfig(e) {
      this.$emit('click:config', e);
    },

    clickUpdateInfo(e) {
      this.$emit('click:update-info', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding-top: 32px;
  .header__title {
    color: rgb(var(--v-theme-info));
    font-size: $font-size-lg;
    font-weight: $font-weight-bold;
  }
  .header__subtitle {
    color: $neutral-color-high-medium;
    font-size: $font-size-xs;
    font-weight: $font-weight-regular;
  }
}
</style>
